import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=a1a16e92&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=a1a16e92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a16e92",
  null
  
)

export default component.exports